import { ADDON_ID, PARAM_KEY } from './chunk-KU2E54FO.mjs';
import React2, { useState, useEffect } from 'react';
import { addons, types, useArgs, useGlobals, useArgTypes, useParameter, useStorybookState } from '@storybook/manager-api';
import { AddonPanel, Spaced, Badge } from '@storybook/components';
import { PureArgsTable } from '@storybook/blocks';

var ControlsPanel = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [args, updateArgs, resetArgs] = useArgs();
  const [globals] = useGlobals();
  const rows = useArgTypes();
  const { expanded, sort, presetColors } = useParameter(PARAM_KEY, {});
  const { path, previewInitialized } = useStorybookState();
  useEffect(() => {
    if (previewInitialized)
      setIsLoading(false);
  }, [previewInitialized]);
  const hasControls = Object.values(rows).some((arg) => arg?.control);
  const withPresetColors = Object.entries(rows).reduce((acc, [key, arg]) => {
    if (arg?.control?.type !== "color" || arg?.control?.presetColors)
      acc[key] = arg;
    else
      acc[key] = { ...arg, control: { ...arg.control, presetColors } };
    return acc;
  }, {});
  return /* @__PURE__ */ React2.createElement(
    PureArgsTable,
    {
      key: path,
      compact: !expanded && hasControls,
      rows: withPresetColors,
      args,
      globals,
      updateArgs,
      resetArgs,
      inAddonPanel: true,
      sort,
      isLoading
    }
  );
};

// src/manager.tsx
function Title() {
  const rows = useArgTypes();
  const controlsCount = Object.values(rows).filter(
    (argType) => argType?.control && !argType?.table?.disable
  ).length;
  const suffix = controlsCount === 0 ? "" : /* @__PURE__ */ React2.createElement(Badge, { status: "neutral" }, controlsCount);
  return /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(Spaced, { col: 1 }, /* @__PURE__ */ React2.createElement("span", { style: { display: "inline-block", verticalAlign: "middle" } }, "Controls"), suffix));
}
addons.register(ADDON_ID, (api) => {
  addons.add(ADDON_ID, {
    title: Title,
    type: types.PANEL,
    paramKey: PARAM_KEY,
    render: ({ active }) => {
      if (!active || !api.getCurrentStoryData()) {
        return null;
      }
      return /* @__PURE__ */ React2.createElement(AddonPanel, { active }, /* @__PURE__ */ React2.createElement(ControlsPanel, null));
    }
  });
});
